import React from 'react'
import InputCustom from 'components/Inputs'
import { FiTrash } from 'react-icons/fi'
import { RiIncreaseDecreaseLine } from 'react-icons/ri'
import { Col, Collapse, Row } from 'reactstrap'
import { SimpleTitleCard } from 'styles/global'
import CardParametrizacao from './CardParametrizacao'
import { BiChevronDown } from 'react-icons/bi'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import { PRODUTO } from 'store/modules/backoffice/produto/types'
import { ParametrizacaoProdutoReq } from 'models/backoffice/produto/type'
import * as produtoActions from 'store/modules/backoffice/produto/actions'
import useRedux from 'hooks/useRedux'

const CardIdade = () => {
  const { register, visualizacao, cardsState, invalids } = useSelector<
    ApplicationState,
    PRODUTO
  >((state) => state.produto)

  const { dispatch } = useRedux()

  type Field = keyof ParametrizacaoProdutoReq

  function onChange(value: string | number, field: Field) {
    dispatch(produtoActions.setRegister({ ...register, [field]: value }))
  }

  function onToggle() {
    dispatch(produtoActions.toggleCard(!cardsState.idade, 'idade'))
  }

  return (
    <CardParametrizacao>
      <div className="d-flex justify-content-between">
        <SimpleTitleCard color="#000" colorIcon="#000">
          <RiIncreaseDecreaseLine className="icon" />
          Idade
        </SimpleTitleCard>
        <BiChevronDown onClick={() => onToggle()} className="toggler" />
      </div>
      <Collapse isOpen={cardsState.idade}>
        <div className="d-flex flex-column row-gap-10">
          <Row>
            <Col>
              <label className="label-12">Faixa etária Inicial</label>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <label className="label-12">Idade</label>
              <InputCustom
                type="number"
                placeholder="Digite aqui"
                onChange={(e) => {
                  onChange(e.target.value, 'idadeDe')
                }}
                value={register.idadeDe || ''}
                disabled={visualizacao}
                min={0}
                max={150}
                invalid={invalids.idadeDe}
              />
            </Col>
            <Col md={3}>
              <label className="label-12">Meses</label>
              <InputCustom
                type="number"
                placeholder="Digite aqui"
                onChange={(e) => {
                  onChange(e.target.value, 'mesesDe')
                }}
                value={register.mesesDe || ''}
                disabled={visualizacao}
                min={0}
                invalid={invalids.mesesDe}
              />
            </Col>
            <Col md={3}>
              <label className="label-12">Dias</label>
              <InputCustom
                type="number"
                placeholder="Digite aqui"
                onChange={(e) => {
                  onChange(e.target.value, 'diasDe')
                }}
                value={register.diasDe || ''}
                disabled={visualizacao}
                min={0}
                invalid={invalids.diasDe}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <label className="label-12">Faixa etária Final</label>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <label className="label-12">Idade</label>
              <InputCustom
                type="number"
                placeholder="Digite aqui"
                onChange={(e) => {
                  onChange(e.target.value, 'idadeAte')
                }}
                value={register.idadeAte || ''}
                disabled={visualizacao}
                min={0}
                max={150}
                invalid={invalids.idadeAte}
              />
            </Col>
            <Col md={3}>
              <label className="label-12">Meses</label>
              <InputCustom
                type="number"
                placeholder="Digite aqui"
                onChange={(e) => {
                  onChange(e.target.value, 'mesesAte')
                }}
                value={register.mesesAte || ''}
                disabled={visualizacao}
                min={0}
                invalid={invalids.mesesAte}
              />
            </Col>
            <Col md={3}>
              <label className="label-12">Dias</label>
              <InputCustom
                type="number"
                placeholder="Digite aqui"
                onChange={(e) => {
                  onChange(e.target.value, 'diasAte')
                }}
                value={register.diasAte || ''}
                disabled={visualizacao}
                min={0}
                invalid={invalids.diasAte}
              />
            </Col>
          </Row>
          <div className="linha-horizontal"></div>
          <Row>
            <Col>
              <label className="info-card">
                O prazo é de acordo com a faixa etária informada acima
              </label>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <label className="label-12">Prazo</label>
              <InputCustom
                type="number"
                placeholder="Digite aqui"
                onChange={(e) => {
                  onChange(e.target.value, 'prazo')
                }}
                value={register.prazo || ''}
                disabled={visualizacao}
                min={0}
                invalid={invalids.prazo}
              />
            </Col>
          </Row>
          <div className="linha-horizontal"></div>
          {!visualizacao && (
            <Row>
              <Col className="d-flex justify-content-end">
                <FiTrash
                  onClick={() => dispatch(produtoActions.cleanIdade())}
                  className="icon-trash"
                />
              </Col>
            </Row>
          )}
        </div>
      </Collapse>
    </CardParametrizacao>
  )
}

export default CardIdade
